import { Paper } from '@mui/material';
import { updateCustomViews } from 'actions/uiActions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Rnd } from 'react-rnd';
import { selectCustomViews } from 'reducers/uiReducer';

export const CustomView = props => {
  const views = useSelector(selectCustomViews);
  const dispatch = useDispatch();
  const view = views[props.viewKey] || {
    x: 400,
    y: 400,
    width: 400,
    length: 400
  };

  const updateView = viewData => {
    console.log({'props.viewKey': props.viewKey, viewData})
    dispatch(updateCustomViews(props.viewKey, viewData));
  };

  return (
    <Rnd
      bounds="parent"
      style={{ zIndex: 9000 }}
      size={{ width: view.width, height: view.height }}
      position={{ x: view.x, y: view.y }}
      onDragStop={(e, d) => {
        updateView({
          ...view,
          x: d.x,
          y: d.y
        });
      }}
      enableResizing={props.edit}
      disableDragging={!props.edit}
      onResizeStop={(e, direction, ref, delta, position) => {
        updateView({
          ...view,
          width: ref.style.width,
          height: ref.style.height
        });
      }}>
      <Paper
        style={{
          height: '100%',
          width: '100%',
          overflow: 'hidden'
        }}>
        {props.children}
      </Paper>
    </Rnd>
  );
};
